import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { catchError, Observable, of, tap, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { MajService } from './maj-service';
import { LigneHeureKmEntite } from '../entites/mecanique/ligne-heure-km';
import { RequeteAjouterHeuresKms } from './requetes/requete-ajouter-heures-kms';
import { MessageService } from 'primeng/api';
@Injectable({ providedIn: 'root' })
export class HeureKmService {

  private obtenirListeUrl = environment.apiBaseUrl + 'heurekm';
  private ajouterHeuresUrl = environment.apiBaseUrl + 'heurekm';
  private approuverHeuresUrl = environment.apiBaseUrl + 'heurekm/approuver';
  private refuserHeuresUrl = environment.apiBaseUrl + 'heurekm/refuser';
  private obtenirHeuresParItemUrl = environment.apiBaseUrl + 'heurekm/item/{numero}';

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private majService: MajService,
    private http: HttpClient,
    public router: Router,
    private messageService: MessageService) { }

  public ObtenirListe(): Observable<LigneHeureKmEntite[]> {
    return this.http.get<LigneHeureKmEntite[]>(this.obtenirListeUrl)
  }


  public Ajouter(requete: RequeteAjouterHeuresKms): Promise<ReponseBase<LigneHeureKmEntite[]>> {
    var p = this.http.post<ReponseBase<LigneHeureKmEntite[]>>(this.ajouterHeuresUrl, JSON.stringify(requete), this.httpOptions)
      .toPromise();

      p.then(() => {
        if (requete.ignorerApprobation) {
          this.majService.Traiter()
        }
        
      });

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Approuver(requete: RequeteAjouterHeuresKms): Promise<ReponseBase<LigneHeureKmEntite[]>> {
    var p = this.http.post<ReponseBase<LigneHeureKmEntite[]>>(this.approuverHeuresUrl, JSON.stringify(requete), this.httpOptions)
      .toPromise();

      p.then(() => this.majService.Traiter());

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public Refuser(requete: RequeteAjouterHeuresKms): Promise<ReponseBase<LigneHeureKmEntite[]>> {
    var p = this.http.post<ReponseBase<LigneHeureKmEntite[]>>(this.refuserHeuresUrl, JSON.stringify(requete), this.httpOptions)
      .toPromise();

      p.catch(() => this.router.navigateByUrl('error'));

      return p;
  }

  public ObtenirHeuresKmsParItem(numero: string): Observable<LigneHeureKmEntite> {
    return this.http.get<LigneHeureKmEntite>(this.obtenirHeuresParItemUrl.replace('{numero}', numero) , {observe: 'response'})
    .pipe(
      tap(x => {
        if (x.status === 204) {
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Cette unité n\'est pas suivi par la mécanique ou est archivée.' });
        }
      }),
      map(response => response.body),
      catchError(error => {
        if (error.status === 404) {
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Unité introuvable.' });
        }
        throw error;
      })
    );
  }
}
